import { getConfigSetup, getStateStore } from "@/utils/utils";
import BaseService from "../base.service"
import axios from "axios";

const state = getStateStore();

const userInfo: any = state.userInfo;
const lang: string = state.lang;
interface reBetSportsInterface {
    url: string
    code: string
    betId: string
    token: string
}
class BetslipsService extends BaseService {
    async cancelBetslip(betslipId: string) {
        const configSetup = getConfigSetup();
        return await this.get(`${configSetup.apiUrl}/api/retail/betslip/cancel/${betslipId}`).then(({ data }) => data)
    }

    async searchBetslip(id: string) {
        const configSetup = getConfigSetup();
        return await this.get(`${configSetup.apiUrl}/api/retail/betslip/detail/${id}`).then(({ data }) => data)
    }

    async reBetSports(param: reBetSportsInterface) {
        const { url, code, betId, token } = param
        const axiosTokenlessInstance = axios.create({
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            },
        })

        const response = await axiosTokenlessInstance.post(`${url}/sports/rebet?admin_user_id=${userInfo?.details?.id}&code=${code}&ref=${betId.replace('S-', '')}&locale=${lang}`)

        return response.data
    }

    async settleBetslip(id: string) {
        const configSetup = getConfigSetup();
        return await this.get(`${configSetup.apiUrl}/api/retail/betslip/cashout/${id}`).then(({ data }) => data)
    }

    async settleRaffle(id: string) {
        const configSetup = getConfigSetup();
        return await this.get(`${configSetup.apiUrl}/api/retail/betslip/cashout-raffle/${id}`).then(({ data }) => data)
    }

    async checkRebetLoto(id: string) {
        const configSetup = getConfigSetup(); 
        return await this.get(`${configSetup.apiUrl}/api/retail/betslip/detail-for-rebet/L-${id}`).then(({ data }) => data)
    }

    async reBetTickets(reference: string) {
        const configSetup = getConfigSetup();
        const payload = {
            account: state.userInfo.gamev3.account,
            currency: state.userInfo.gamev3.currency_code,
            reference: reference,
            client_token: state.userInfo.gamev3.token,
        }

        const response = await this.postAuth2(`${configSetup.apiGame}/api/multi-lotto/wager`, payload)

        return response.data
    }

    // lotto daily
    async reBetDailyTickets(reference: string, token: string) {
        const configSetup = getConfigSetup();
        const payload = {
            account: configSetup.account,
            currency: configSetup.currency,
            reference: reference,
            client_token: token,
        };

        const response = await this.postAuth2(`${configSetup.apiGame}/api/v2/fixed-daily-lotto/wager`, payload, {
            headers: {
                Authorization: configSetup.tokenV3,
            },
        });

        return response.data;
    }

    async updatePrintingStatus(ticketType:string, reference: string, reprintCount = 0) {
        const configSetup = getConfigSetup(); 
        const payload = {ticketType, reference, reprintCount, reprint: reprintCount > 0}
        return await this.post(`${configSetup.apiUrl}/api/retail/cashier/update-print-status`, payload).then(({ data }) => data)
    }
}

export default new BetslipsService()